'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.endOfWeek;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/endOfWeek.js
// module id = 266
// module chunks = 0